/* ERA - bascule rupture / liste d'attente.
   Regle unique : un compteur de stock affichant un nombre <= 0 vaut rupture.
   La precommande a ete retiree le 12/09/2026 : un produit en rupture n'est
   plus achetable, la cliente s'inscrit pour etre prevenue du retour.

   Repartition serveur / client :
   - les tuiles add-on en rupture sont rendues par sections/product.liquid, sans
     bouton AJOUTER et avec le declencheur ETRE PREVENUE ; le theme les ignore
     donc dans le total de la selection. Rien a masquer ici.
   - ce fichier ne traite que ce que le serveur ne peut pas voir : les pastilles
     du tiroir de panier et des cartes de collection (injectees en JS), et le
     bouton principal de la fiche, que section-product.js reecrit a chaque rendu.

   Bouton principal, deux cas :
   1. fiche sans add-ons (le coffret) : le bouton vaut ETRE PREVENUE en
      permanence tant que la page est en rupture.
   2. fiche a add-ons (les brumes) : le bouton pilote la selection. Il vaut
      ETRE PREVENUE tant que la selection est vide, et redevient le bouton du
      theme des qu'une brume disponible est choisie. */
(function () {
  'use strict';

  var TEXTE_LONG = 'RUPTURE DE STOCK';
  var TEXTE_COURT = 'RUPTURE';
  var LABEL_ATTENTE = 'ÊTRE PRÉVENUE DU RETOUR';
  var MENTION = 'Indisponible — inscris-toi pour être prévenue du retour.';

  function premierEntier(t) {
    if (!t) return null;
    var m = t.replace(/[  ]/g, ' ').match(/-?\d+/);
    return m ? parseInt(m[0], 10) : null;
  }

  function marquer(el, texte) {
    el.setAttribute('data-era-fait', '1');
    el.setAttribute('data-era-rupture', '');
    el.textContent = texte;
  }

  function poserMention(ancre, actif, cle) {
    var existant = document.querySelector('[data-era-note="' + cle + '"]');
    if (actif && ancre) {
      if (!existant) {
        var el = document.createElement('p');
        el.className = 'era-preorder-note';
        el.setAttribute('data-era-note', cle);
        el.textContent = MENTION;
        if (ancre.parentNode) ancre.parentNode.insertBefore(el, ancre.nextSibling);
      }
    } else if (existant && existant.parentNode) {
      existant.parentNode.removeChild(existant);
    }
  }

  function ouvrirModale(handle) {
    if (typeof window.eraWaitlistOuvrir === 'function') window.eraWaitlistOuvrir(handle);
  }

  /* Pastilles injectees cote client. Les badges des tuiles add-on en rupture
     portent deja data-era-fait depuis le serveur : ils sont ignores ici. */
  function traiterBadges() {
    document.querySelectorAll('.product__addon-badge').forEach(function (el) {
      if (el.getAttribute('data-era-fait') === '1') return;
      var n = premierEntier(el.textContent);
      if (n === null || n > 0) return;
      marquer(el, TEXTE_LONG);
    });
    ['.cart-drawer__stock', '.sd-featured-collection__stock-badge'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.getAttribute('data-era-fait') === '1') return;
        var n = premierEntier(el.textContent);
        if (n === null || n > 0) return;
        marquer(el, TEXTE_COURT);
      });
    });
  }

  /* Declencheurs rendus par le serveur : on ne branche qu'une fois. */
  function brancherDeclencheurs() {
    document.querySelectorAll('[data-era-wl-trigger]').forEach(function (b) {
      if (b.getAttribute('data-era-branche') === '1') return;
      b.setAttribute('data-era-branche', '1');
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        ouvrirModale(b.getAttribute('data-era-wl-handle') || '');
      });
    });
  }

  /* Total de la selection, lu sur les tuiles telles que le theme les tient.
     Une tuile en rupture n'a pas de controle de quantite : son attribut
     data-addon-quantity n'existe pas, elle compte donc pour zero. */
  function totalSelection() {
    var total = 0;
    document.querySelectorAll('[data-addon-action]').forEach(function (a) {
      total += Number(a.getAttribute('data-addon-quantity') || 0);
    });
    return total;
  }

  function traiterFicheProduit() {
    var b = document.querySelector('[data-product-submit]');
    if (!b) return;
    var normal = b.getAttribute('data-era-label-normal');
    var attente = b.getAttribute('data-era-label-preorder') || LABEL_ATTENTE;
    if (!normal) return;

    var pageEnRupture = b.getAttribute('data-era-page-rupture') === 'true';
    var avecAddons = b.getAttribute('data-product-submit-requires-addons') === 'true';

    /* On n'intercepte que si la page est en rupture ET, sur une fiche a
       add-ons, tant qu'aucune brume disponible n'a ete selectionnee. */
    var intercepte = pageEnRupture && (!avecAddons || totalSelection() === 0);
    b.setAttribute('data-era-page-preorder', intercepte ? 'true' : 'false');

    var label = b.querySelector('[data-product-submit-label]');

    if (intercepte) {
      if (b.disabled) b.disabled = false;
      if (label && label.textContent.trim() !== attente) label.textContent = attente;
      /* Le theme repose ce libelle a chaque rendu : on le garde aligne. */
      if (label && label.dataset && label.dataset.initialLabel !== attente) {
        label.dataset.initialLabel = attente;
      }
      if (!avecAddons && b.getAttribute('data-add-to-cart-label') !== attente) {
        b.setAttribute('data-add-to-cart-label', attente);
      }
    } else if (!avecAddons && b.getAttribute('data-add-to-cart-label') !== normal) {
      b.setAttribute('data-add-to-cart-label', normal);
    }

    var collant = document.querySelector('[data-product-sticky-label]');
    if (collant && label && collant.textContent !== label.textContent) {
      collant.textContent = label.textContent;
    }
    var boutonCollant = document.querySelector('[data-product-sticky-submit]');
    if (boutonCollant && intercepte && boutonCollant.disabled) boutonCollant.disabled = false;

    poserMention(b, intercepte, 'fiche');
  }

  /* Le bouton principal ne soumet plus le formulaire quand l'interception est
     active : il ouvre la modale. Capture pour passer avant le theme. */
  function brancherFiche() {
    document.addEventListener(
      'click',
      function (e) {
        var cible = e.target && e.target.closest ? e.target.closest('[data-product-submit], [data-product-sticky-submit]') : null;
        if (!cible) return;
        var b = document.querySelector('[data-product-submit]');
        if (!b || b.getAttribute('data-era-page-preorder') !== 'true') return;
        e.preventDefault();
        e.stopPropagation();
        ouvrirModale(b.getAttribute('data-era-page-handle') || '');
      },
      true
    );
  }

  var enCours = false;
  function passe() {
    if (enCours) return;
    enCours = true;
    try { traiterBadges(); brancherDeclencheurs(); traiterFicheProduit(); } catch (e) {}
    enCours = false;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', passe);
  else passe();
  brancherFiche();

  /* section-product.js pose data-addon-quantity a chaque rendu : l'observateur
     suffit des qu'une tuile disponible existe. Les passes differees couvrent le
     cas ou toutes les tuiles sont en rupture, ou aucune mutation n'a lieu. */
  [0, 250, 800, 2000].forEach(function (d) { setTimeout(passe, d); });

  var t = null;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(passe, 60); })
    .observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-addon-quantity', 'disabled'] });

  document.addEventListener('click', function () { setTimeout(passe, 120); setTimeout(passe, 500); }, true);
})();
